import { render, staticRenderFns } from "./MainStatistic.vue?vue&type=template&id=471d1e6c&"
import script from "./MainStatistic.vue?vue&type=script&lang=ts&"
export * from "./MainStatistic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports